export const appWindows = [
  { id: "timeline" },
  { id: "comparativo" },
  { id: "stacks" },
  { id: "metodo" },
  { id: "mantra" },
  { id: "ia_operacional" },
  { id: "gitflow" },
  { id: "resume_summary" },
  { id: "resume_contacts" },
  { id: "resume_skills" },
  { id: "resume_experience" },
  { id: "resume_education" },
  { id: "portfolio_contact" },
];
